/**
 * This file is automatically generated by `yarn generate-classes`.
 * DO NOT MANUALLY EDIT IT OR YOUR CHANGES WILL BE LOST!
 */

import type { AccelerationBands } from "./../charts/stock/indicators/AccelerationBands.js";
import type { AccumulationDistribution } from "./../charts/stock/indicators/AccumulationDistribution.js";
import type { AccumulativeSwingIndex } from "./../charts/stock/indicators/AccumulativeSwingIndex.js";
import type { Annotator } from "./../plugins/exporting/Annotator.js";
import type { ArcDiagram } from "./../charts/flow/ArcDiagram.js";
import type { ArcDiagramLink } from "./../charts/flow/ArcDiagramLink.js";
import type { ArcDiagramNodes } from "./../charts/flow/ArcDiagramNodes.js";
import type { Aroon } from "./../charts/stock/indicators/Aroon.js";
import type { AverageSeries } from "./../charts/stock/drawing/AverageSeries.js";
import type { AverageTrueRange } from "./../charts/stock/indicators/AverageTrueRange.js";
import type { AwesomeOscillator } from "./../charts/stock/indicators/AwesomeOscillator.js";
import type { Axis } from "./../charts/xy/axes/Axis.js";
import type { AxisBullet } from "./../charts/xy/axes/AxisBullet.js";
import type { AxisLabel } from "./../charts/xy/axes/AxisLabel.js";
import type { AxisLabelRadial } from "./../charts/xy/axes/AxisLabelRadial.js";
import type { AxisRenderer } from "./../charts/xy/axes/AxisRenderer.js";
import type { AxisRendererCircular } from "./../charts/radar/AxisRendererCircular.js";
import type { AxisRendererCurveX } from "./../charts/timeline/AxisRendererCurveX.js";
import type { AxisRendererCurveY } from "./../charts/timeline/AxisRendererCurveY.js";
import type { AxisRendererRadial } from "./../charts/radar/AxisRendererRadial.js";
import type { AxisRendererX } from "./../charts/xy/axes/AxisRendererX.js";
import type { AxisRendererY } from "./../charts/xy/axes/AxisRendererY.js";
import type { AxisTick } from "./../charts/xy/axes/AxisTick.js";
import type { BaseColumnSeries } from "./../charts/xy/series/BaseColumnSeries.js";
import type { BollingerBands } from "./../charts/stock/indicators/BollingerBands.js";
import type { BreadcrumbBar } from "./../charts/hierarchy/BreadcrumbBar.js";
import type { BullBearPower } from "./../charts/stock/indicators/BullBearPower.js";
import type { Bullet } from "./render/Bullet.js";
import type { Button } from "./render/Button.js";
import type { CalloutSeries } from "./../charts/stock/drawing/CalloutSeries.js";
import type { Candlestick } from "./../charts/xy/series/Candlestick.js";
import type { CandlestickSeries } from "./../charts/xy/series/CandlestickSeries.js";
import type { CategoryAxis } from "./../charts/xy/axes/CategoryAxis.js";
import type { CategoryDateAxis } from "./../charts/xy/axes/CategoryDateAxis.js";
import type { ChaikinMoneyFlow } from "./../charts/stock/indicators/ChaikinMoneyFlow.js";
import type { ChaikinOscillator } from "./../charts/stock/indicators/ChaikinOscillator.js";
import type { Chart } from "./render/Chart.js";
import type { ChartIndicator } from "./../charts/stock/indicators/ChartIndicator.js";
import type { ChartSerializer } from "./../plugins/json/ChartSerializer.js";
import type { Chord } from "./../charts/flow/Chord.js";
import type { ChordDirected } from "./../charts/flow/ChordDirected.js";
import type { ChordLink } from "./../charts/flow/ChordLink.js";
import type { ChordLinkDirected } from "./../charts/flow/ChordLinkDirected.js";
import type { ChordNodes } from "./../charts/flow/ChordNodes.js";
import type { ChordNonRibbon } from "./../charts/flow/ChordNonRibbon.js";
import type { Circle } from "./render/Circle.js";
import type { CirclePattern } from "./render/patterns/CirclePattern.js";
import type { ClockHand } from "./../charts/radar/ClockHand.js";
import type { ClusteredPointSeries } from "./../charts/map/ClusteredPointSeries.js";
import type { ColorControl } from "./../charts/stock/toolbar/ColorControl.js";
import type { ColorPicker } from "./../plugins/colorPicker/ColorPicker.js";
import type { ColorPickerButton } from "./../plugins/colorPicker/ColorPickerButton.js";
import type { ColorSet } from "./util/ColorSet.js";
import type { ColumnSeries } from "./../charts/xy/series/ColumnSeries.js";
import type { CommodityChannelIndex } from "./../charts/stock/indicators/CommodityChannelIndex.js";
import type { ComparisonControl } from "./../charts/stock/toolbar/ComparisonControl.js";
import type { Component } from "./render/Component.js";
import type { ConfirmButton } from "./render/ConfirmButton.js";
import type { Container } from "./render/Container.js";
import type { CurveChart } from "./../charts/timeline/CurveChart.js";
import type { CurveColumnSeries } from "./../charts/timeline/CurveColumnSeries.js";
import type { CurveCursor } from "./../charts/timeline/CurveCursor.js";
import type { CurveLineSeries } from "./../charts/timeline/CurveLineSeries.js";
import type { DataSaveControl } from "./../charts/stock/toolbar/DataSaveControl.js";
import type { DateAxis } from "./../charts/xy/axes/DateAxis.js";
import type { DateFormatter } from "./util/DateFormatter.js";
import type { DateRangeSelector } from "./../charts/stock/toolbar/DateRangeSelector.js";
import type { DisparityIndex } from "./../charts/stock/indicators/DisparityIndex.js";
import type { DoodleSeries } from "./../charts/stock/drawing/DoodleSeries.js";
import type { DrawingControl } from "./../charts/stock/toolbar/DrawingControl.js";
import type { DrawingSeries } from "./../charts/stock/drawing/DrawingSeries.js";
import type { DrawingToolControl } from "./../charts/stock/toolbar/DrawingToolControl.js";
import type { Dropdown } from "./../charts/stock/toolbar/Dropdown.js";
import type { DropdownColors } from "./../charts/stock/toolbar/DropdownColors.js";
import type { DropdownControl } from "./../charts/stock/toolbar/DropdownControl.js";
import type { DropdownList } from "./../charts/stock/toolbar/DropdownList.js";
import type { DropdownListControl } from "./../charts/stock/toolbar/DropdownListControl.js";
import type { DurationAxis } from "./../charts/xy/axes/DurationAxis.js";
import type { DurationFormatter } from "./util/DurationFormatter.js";
import type { EditableAxisLabel } from "./../charts/xy/axes/EditableAxisLabel.js";
import type { EditableLabel } from "./render/EditableLabel.js";
import type { Ellipse } from "./render/Ellipse.js";
import type { EllipseSeries } from "./../charts/stock/drawing/EllipseSeries.js";
import type { Entity } from "./util/Entity.js";
import type { Exporting } from "./../plugins/exporting/Exporting.js";
import type { ExportingMenu } from "./../plugins/exporting/ExportingMenu.js";
import type { FibonacciSeries } from "./../charts/stock/drawing/FibonacciSeries.js";
import type { FibonacciTimezoneSeries } from "./../charts/stock/drawing/FibonacciTimezoneSeries.js";
import type { Flow } from "./../charts/flow/Flow.js";
import type { FlowLink } from "./../charts/flow/FlowLink.js";
import type { FlowNode } from "./../charts/flow/FlowNode.js";
import type { FlowNodes } from "./../charts/flow/FlowNodes.js";
import type { ForceDirected } from "./../charts/hierarchy/ForceDirected.js";
import type { FunnelSeries } from "./../charts/funnel/FunnelSeries.js";
import type { FunnelSlice } from "./../charts/funnel/FunnelSlice.js";
import type { Gantt } from "./../charts/gantt/Gantt.js";
import type { GanttCategoryAxis } from "./../charts/gantt/GanttCategoryAxis.js";
import type { GanttCategoryAxisRenderer } from "./../charts/gantt/GanttCategoryAxisRenderer.js";
import type { GanttDateAxis } from "./../charts/gantt/GanttDateAxis.js";
import type { GanttDateAxisRenderer } from "./../charts/gantt/GanttDateAxisRenderer.js";
import type { GanttSeries } from "./../charts/gantt/GanttSeries.js";
import type { GaplessDateAxis } from "./../charts/xy/axes/GaplessDateAxis.js";
import type { Gradient } from "./render/gradients/Gradient.js";
import type { GrainPattern } from "./render/patterns/GrainPattern.js";
import type { Graphics } from "./render/Graphics.js";
import type { GraticuleSeries } from "./../charts/map/GraticuleSeries.js";
import type { Grid } from "./../charts/xy/axes/Grid.js";
import type { GridLayout } from "./render/GridLayout.js";
import type { HeatLegend } from "./render/HeatLegend.js";
import type { HeikinAshi } from "./../charts/stock/indicators/HeikinAshi.js";
import type { Hierarchy } from "./../charts/hierarchy/Hierarchy.js";
import type { HierarchyLink } from "./../charts/hierarchy/HierarchyLink.js";
import type { HierarchyNode } from "./../charts/hierarchy/HierarchyNode.js";
import type { HorizontalLayout } from "./render/HorizontalLayout.js";
import type { HorizontalLineSeries } from "./../charts/stock/drawing/HorizontalLineSeries.js";
import type { HorizontalRaySeries } from "./../charts/stock/drawing/HorizontalRaySeries.js";
import type { IconControl } from "./../charts/stock/toolbar/IconControl.js";
import type { IconSeries } from "./../charts/stock/drawing/IconSeries.js";
import type { Indicator } from "./../charts/stock/indicators/Indicator.js";
import type { IndicatorControl } from "./../charts/stock/toolbar/IndicatorControl.js";
import type { InterfaceColors } from "./util/InterfaceColors.js";
import type { IntervalControl } from "./../charts/stock/toolbar/IntervalControl.js";
import type { Label } from "./render/Label.js";
import type { LabelSeries } from "./../charts/stock/drawing/LabelSeries.js";
import type { Layout } from "./render/Layout.js";
import type { Legend } from "./render/Legend.js";
import type { Line } from "./render/Line.js";
import type { LineArrowSeries } from "./../charts/stock/drawing/LineArrowSeries.js";
import type { LinePattern } from "./render/patterns/LinePattern.js";
import type { LineSeries } from "./../charts/xy/series/LineSeries.js";
import type { LinearGradient } from "./render/gradients/LinearGradient.js";
import type { Link } from "./render/Link.js";
import type { LinkedHierarchy } from "./../charts/hierarchy/LinkedHierarchy.js";
import type { LinkedHierarchyNode } from "./../charts/hierarchy/LinkedHierarchyNode.js";
import type { MACD } from "./../charts/stock/indicators/MACD.js";
import type { MACross } from "./../charts/stock/indicators/MACross.js";
import type { MapChart } from "./../charts/map/MapChart.js";
import type { MapLine } from "./../charts/map/MapLine.js";
import type { MapLineSeries } from "./../charts/map/MapLineSeries.js";
import type { MapPointSeries } from "./../charts/map/MapPointSeries.js";
import type { MapPolygon } from "./../charts/map/MapPolygon.js";
import type { MapPolygonSeries } from "./../charts/map/MapPolygonSeries.js";
import type { MapRasterSeries } from "./../charts/map/MapRasterSeries.js";
import type { MapSankeyNodes } from "./../charts/map/MapSankeyNodes.js";
import type { MapSankeySeries } from "./../charts/map/MapSankeySeries.js";
import type { MapSeries } from "./../charts/map/MapSeries.js";
import type { Measure } from "./../charts/stock/drawing/Measure.js";
import type { MedianPrice } from "./../charts/stock/indicators/MedianPrice.js";
import type { Modal } from "./util/Modal.js";
import type { Momentum } from "./../charts/stock/indicators/Momentum.js";
import type { MovingAverage } from "./../charts/stock/indicators/MovingAverage.js";
import type { MovingAverageDeviation } from "./../charts/stock/indicators/MovingAverageDeviation.js";
import type { MovingAverageEnvelope } from "./../charts/stock/indicators/MovingAverageEnvelope.js";
import type { NightSeries } from "./../charts/map/NightSeries.js";
import type { NumberFormatter } from "./util/NumberFormatter.js";
import type { NumericStepper } from "./render/NumericStepper.js";
import type { OHLC } from "./../charts/xy/series/OHLC.js";
import type { OHLCSeries } from "./../charts/xy/series/OHLCSeries.js";
import type { OnBalanceVolume } from "./../charts/stock/indicators/OnBalanceVolume.js";
import type { OrthogonalLine } from "./render/OrthogonalLine.js";
import type { OverboughtOversold } from "./../charts/stock/indicators/OverboughtOversold.js";
import type { PVT } from "./../charts/stock/indicators/PVT.js";
import type { Pack } from "./../charts/hierarchy/Pack.js";
import type { PanelControls } from "./../charts/stock/PanelControls.js";
import type { ParallelChannelSeries } from "./../charts/stock/drawing/ParallelChannelSeries.js";
import type { Partition } from "./../charts/hierarchy/Partition.js";
import type { PathPattern } from "./render/patterns/PathPattern.js";
import type { Pattern } from "./render/patterns/Pattern.js";
import type { PatternSet } from "./util/PatternSet.js";
import type { PercentChart } from "./../charts/percent/PercentChart.js";
import type { PercentSeries } from "./../charts/percent/PercentSeries.js";
import type { PeriodSelector } from "./../charts/stock/toolbar/PeriodSelector.js";
import type { PictorialStackedSeries } from "./../charts/funnel/PictorialStackedSeries.js";
import type { Picture } from "./render/Picture.js";
import type { PicturePattern } from "./render/patterns/PicturePattern.js";
import type { PieChart } from "./../charts/pie/PieChart.js";
import type { PieSeries } from "./../charts/pie/PieSeries.js";
import type { PixelMapSeries } from "./../charts/map/PixelMapSeries.js";
import type { PointedRectangle } from "./render/PointedRectangle.js";
import type { Polygon } from "./render/Polygon.js";
import type { PolylineSeries } from "./../charts/stock/drawing/PolylineSeries.js";
import type { ProgressPie } from "./render/ProgressPie.js";
import type { PyramidSeries } from "./../charts/funnel/PyramidSeries.js";
import type { QuadrantLineSeries } from "./../charts/stock/drawing/QuadrantLineSeries.js";
import type { RadarChart } from "./../charts/radar/RadarChart.js";
import type { RadarColumnSeries } from "./../charts/radar/RadarColumnSeries.js";
import type { RadarCursor } from "./../charts/radar/RadarCursor.js";
import type { RadarLineSeries } from "./../charts/radar/RadarLineSeries.js";
import type { RadialGradient } from "./render/gradients/RadialGradient.js";
import type { RadialLabel } from "./render/RadialLabel.js";
import type { RadialText } from "./render/RadialText.js";
import type { Rectangle } from "./render/Rectangle.js";
import type { RectanglePattern } from "./render/patterns/RectanglePattern.js";
import type { RectangleSeries } from "./../charts/stock/drawing/RectangleSeries.js";
import type { RegressionSeries } from "./../charts/stock/drawing/RegressionSeries.js";
import type { RelativeStrengthIndex } from "./../charts/stock/indicators/RelativeStrengthIndex.js";
import type { ResetControl } from "./../charts/stock/toolbar/ResetControl.js";
import type { RoundedRectangle } from "./render/RoundedRectangle.js";
import type { Sankey } from "./../charts/flow/Sankey.js";
import type { SankeyLink } from "./../charts/flow/SankeyLink.js";
import type { SankeyNodes } from "./../charts/flow/SankeyNodes.js";
import type { Scrollbar } from "./render/Scrollbar.js";
import type { SerialChart } from "./render/SerialChart.js";
import type { SerialChartContainer } from "./render/SerialChartContainer.js";
import type { Serializer } from "./../plugins/json/Serializer.js";
import type { Series } from "./render/Series.js";
import type { SeriesTypeControl } from "./../charts/stock/toolbar/SeriesTypeControl.js";
import type { SerpentineChart } from "./../charts/timeline/SerpentineChart.js";
import type { SettingsControl } from "./../charts/stock/toolbar/SettingsControl.js";
import type { SettingsModal } from "./../charts/stock/SettingsModal.js";
import type { SimpleLineSeries } from "./../charts/stock/drawing/SimpleLineSeries.js";
import type { Slice } from "./render/Slice.js";
import type { SliceGrouper } from "./../plugins/sliceGrouper/SliceGrouper.js";
import type { SlicedChart } from "./../charts/funnel/SlicedChart.js";
import type { Slider } from "./render/Slider.js";
import type { SmoothedRadarLineSeries } from "./../charts/radar/SmoothedRadarLineSeries.js";
import type { SmoothedXLineSeries } from "./../charts/xy/series/SmoothedXLineSeries.js";
import type { SmoothedXYLineSeries } from "./../charts/xy/series/SmoothedXYLineSeries.js";
import type { SmoothedYLineSeries } from "./../charts/xy/series/SmoothedYLineSeries.js";
import type { SpiralChart } from "./../charts/timeline/SpiralChart.js";
import type { Sprite } from "./render/Sprite.js";
import type { SpriteResizer } from "./render/SpriteResizer.js";
import type { StandardDeviation } from "./../charts/stock/indicators/StandardDeviation.js";
import type { Star } from "./render/Star.js";
import type { StarPattern } from "./render/patterns/StarPattern.js";
import type { StepLineSeries } from "./../charts/xy/series/StepLineSeries.js";
import type { StochasticMomentumIndex } from "./../charts/stock/indicators/StochasticMomentumIndex.js";
import type { StochasticOscillator } from "./../charts/stock/indicators/StochasticOscillator.js";
import type { StockChart } from "./../charts/stock/StockChart.js";
import type { StockControl } from "./../charts/stock/toolbar/StockControl.js";
import type { StockLegend } from "./../charts/stock/StockLegend.js";
import type { StockPanel } from "./../charts/stock/StockPanel.js";
import type { StockToolbar } from "./../charts/stock/toolbar/StockToolbar.js";
import type { Sunburst } from "./../charts/hierarchy/Sunburst.js";
import type { SuperTrend } from "./../charts/stock/indicators/SuperTrend.js";
import type { Text } from "./render/Text.js";
import type { Tick } from "./render/Tick.js";
import type { Tooltip } from "./render/Tooltip.js";
import type { Tree } from "./../charts/hierarchy/Tree.js";
import type { Treemap } from "./../charts/hierarchy/Treemap.js";
import type { TrendLineSeries } from "./../charts/stock/drawing/TrendLineSeries.js";
import type { Triangle } from "./render/Triangle.js";
import type { TrianglePattern } from "./render/patterns/TrianglePattern.js";
import type { Trix } from "./../charts/stock/indicators/Trix.js";
import type { TypicalPrice } from "./../charts/stock/indicators/TypicalPrice.js";
import type { VWAP } from "./../charts/stock/indicators/VWAP.js";
import type { ValueAxis } from "./../charts/xy/axes/ValueAxis.js";
import type { Venn } from "./../charts/venn/Venn.js";
import type { VerticalLayout } from "./render/VerticalLayout.js";
import type { VerticalLineSeries } from "./../charts/stock/drawing/VerticalLineSeries.js";
import type { Volume } from "./../charts/stock/indicators/Volume.js";
import type { VolumeProfile } from "./../charts/stock/indicators/VolumeProfile.js";
import type { VoronoiTreemap } from "./../charts/hierarchy/VoronoiTreemap.js";
import type { WilliamsR } from "./../charts/stock/indicators/WilliamsR.js";
import type { WordCloud } from "./../charts/wordcloud/WordCloud.js";
import type { XYChart } from "./../charts/xy/XYChart.js";
import type { XYChartScrollbar } from "./../charts/xy/XYChartScrollbar.js";
import type { XYCursor } from "./../charts/xy/XYCursor.js";
import type { XYSeries } from "./../charts/xy/series/XYSeries.js";
import type { ZigZag } from "./../charts/stock/indicators/ZigZag.js";
import type { ZoomControl } from "./../charts/map/ZoomControl.js";
import type { ZoomTools } from "./render/ZoomTools.js";
import type { ZoomableContainer } from "./render/ZoomableContainer.js";

export interface IClasses {
	"AccelerationBands": AccelerationBands;
	"AccumulationDistribution": AccumulationDistribution;
	"AccumulativeSwingIndex": AccumulativeSwingIndex;
	"Annotator": Annotator;
	"ArcDiagram": ArcDiagram;
	"ArcDiagramLink": ArcDiagramLink;
	"ArcDiagramNodes": ArcDiagramNodes;
	"Aroon": Aroon;
	"AverageSeries": AverageSeries;
	"AverageTrueRange": AverageTrueRange;
	"AwesomeOscillator": AwesomeOscillator;
	"Axis": Axis<AxisRenderer>;
	"AxisBullet": AxisBullet;
	"AxisLabel": AxisLabel;
	"AxisLabelRadial": AxisLabelRadial;
	"AxisRenderer": AxisRenderer;
	"AxisRendererCircular": AxisRendererCircular;
	"AxisRendererCurveX": AxisRendererCurveX;
	"AxisRendererCurveY": AxisRendererCurveY;
	"AxisRendererRadial": AxisRendererRadial;
	"AxisRendererX": AxisRendererX;
	"AxisRendererY": AxisRendererY;
	"AxisTick": AxisTick;
	"BaseColumnSeries": BaseColumnSeries;
	"BollingerBands": BollingerBands;
	"BreadcrumbBar": BreadcrumbBar;
	"BullBearPower": BullBearPower;
	"Bullet": Bullet;
	"Button": Button;
	"CalloutSeries": CalloutSeries;
	"Candlestick": Candlestick;
	"CandlestickSeries": CandlestickSeries;
	"CategoryAxis": CategoryAxis<AxisRenderer>;
	"CategoryDateAxis": CategoryDateAxis<AxisRenderer>;
	"ChaikinMoneyFlow": ChaikinMoneyFlow;
	"ChaikinOscillator": ChaikinOscillator;
	"Chart": Chart;
	"ChartIndicator": ChartIndicator;
	"ChartSerializer": ChartSerializer;
	"Chord": Chord;
	"ChordDirected": ChordDirected;
	"ChordLink": ChordLink;
	"ChordLinkDirected": ChordLinkDirected;
	"ChordNodes": ChordNodes;
	"ChordNonRibbon": ChordNonRibbon;
	"Circle": Circle;
	"CirclePattern": CirclePattern;
	"ClockHand": ClockHand;
	"ClusteredPointSeries": ClusteredPointSeries;
	"ColorControl": ColorControl;
	"ColorPicker": ColorPicker;
	"ColorPickerButton": ColorPickerButton;
	"ColorSet": ColorSet;
	"ColumnSeries": ColumnSeries;
	"CommodityChannelIndex": CommodityChannelIndex;
	"ComparisonControl": ComparisonControl;
	"Component": Component;
	"ConfirmButton": ConfirmButton;
	"Container": Container;
	"CurveChart": CurveChart;
	"CurveColumnSeries": CurveColumnSeries;
	"CurveCursor": CurveCursor;
	"CurveLineSeries": CurveLineSeries;
	"DataSaveControl": DataSaveControl;
	"DateAxis": DateAxis<AxisRenderer>;
	"DateFormatter": DateFormatter;
	"DateRangeSelector": DateRangeSelector;
	"DisparityIndex": DisparityIndex;
	"DoodleSeries": DoodleSeries;
	"DrawingControl": DrawingControl;
	"DrawingSeries": DrawingSeries;
	"DrawingToolControl": DrawingToolControl;
	"Dropdown": Dropdown;
	"DropdownColors": DropdownColors;
	"DropdownControl": DropdownControl;
	"DropdownList": DropdownList;
	"DropdownListControl": DropdownListControl;
	"DurationAxis": DurationAxis<AxisRenderer>;
	"DurationFormatter": DurationFormatter;
	"EditableAxisLabel": EditableAxisLabel;
	"EditableLabel": EditableLabel;
	"Ellipse": Ellipse;
	"EllipseSeries": EllipseSeries;
	"Entity": Entity;
	"Exporting": Exporting;
	"ExportingMenu": ExportingMenu;
	"FibonacciSeries": FibonacciSeries;
	"FibonacciTimezoneSeries": FibonacciTimezoneSeries;
	"Flow": Flow;
	"FlowLink": FlowLink;
	"FlowNode": FlowNode;
	"FlowNodes": FlowNodes;
	"ForceDirected": ForceDirected;
	"FunnelSeries": FunnelSeries;
	"FunnelSlice": FunnelSlice;
	"Gantt": Gantt;
	"GanttCategoryAxis": GanttCategoryAxis<GanttCategoryAxisRenderer>;
	"GanttCategoryAxisRenderer": GanttCategoryAxisRenderer;
	"GanttDateAxis": GanttDateAxis<GanttDateAxisRenderer>;
	"GanttDateAxisRenderer": GanttDateAxisRenderer;
	"GanttSeries": GanttSeries;
	"GaplessDateAxis": GaplessDateAxis<AxisRenderer>;
	"Gradient": Gradient;
	"GrainPattern": GrainPattern;
	"Graphics": Graphics;
	"GraticuleSeries": GraticuleSeries;
	"Grid": Grid;
	"GridLayout": GridLayout;
	"HeatLegend": HeatLegend;
	"HeikinAshi": HeikinAshi;
	"Hierarchy": Hierarchy;
	"HierarchyLink": HierarchyLink;
	"HierarchyNode": HierarchyNode;
	"HorizontalLayout": HorizontalLayout;
	"HorizontalLineSeries": HorizontalLineSeries;
	"HorizontalRaySeries": HorizontalRaySeries;
	"IconControl": IconControl;
	"IconSeries": IconSeries;
	"Indicator": Indicator;
	"IndicatorControl": IndicatorControl;
	"InterfaceColors": InterfaceColors;
	"IntervalControl": IntervalControl;
	"Label": Label;
	"LabelSeries": LabelSeries;
	"Layout": Layout;
	"Legend": Legend;
	"Line": Line;
	"LineArrowSeries": LineArrowSeries;
	"LinePattern": LinePattern;
	"LineSeries": LineSeries;
	"LinearGradient": LinearGradient;
	"Link": Link;
	"LinkedHierarchy": LinkedHierarchy;
	"LinkedHierarchyNode": LinkedHierarchyNode;
	"MACD": MACD;
	"MACross": MACross;
	"MapChart": MapChart;
	"MapLine": MapLine;
	"MapLineSeries": MapLineSeries;
	"MapPointSeries": MapPointSeries;
	"MapPolygon": MapPolygon;
	"MapPolygonSeries": MapPolygonSeries;
	"MapRasterSeries": MapRasterSeries;
	"MapSankeyNodes": MapSankeyNodes;
	"MapSankeySeries": MapSankeySeries;
	"MapSeries": MapSeries;
	"Measure": Measure;
	"MedianPrice": MedianPrice;
	"Modal": Modal;
	"Momentum": Momentum;
	"MovingAverage": MovingAverage;
	"MovingAverageDeviation": MovingAverageDeviation;
	"MovingAverageEnvelope": MovingAverageEnvelope;
	"NightSeries": NightSeries;
	"NumberFormatter": NumberFormatter;
	"NumericStepper": NumericStepper;
	"OHLC": OHLC;
	"OHLCSeries": OHLCSeries;
	"OnBalanceVolume": OnBalanceVolume;
	"OrthogonalLine": OrthogonalLine;
	"OverboughtOversold": OverboughtOversold;
	"PVT": PVT;
	"Pack": Pack;
	"PanelControls": PanelControls;
	"ParallelChannelSeries": ParallelChannelSeries;
	"Partition": Partition;
	"PathPattern": PathPattern;
	"Pattern": Pattern;
	"PatternSet": PatternSet;
	"PercentChart": PercentChart;
	"PercentSeries": PercentSeries;
	"PeriodSelector": PeriodSelector;
	"PictorialStackedSeries": PictorialStackedSeries;
	"Picture": Picture;
	"PicturePattern": PicturePattern;
	"PieChart": PieChart;
	"PieSeries": PieSeries;
	"PixelMapSeries": PixelMapSeries;
	"PointedRectangle": PointedRectangle;
	"Polygon": Polygon;
	"PolylineSeries": PolylineSeries;
	"ProgressPie": ProgressPie;
	"PyramidSeries": PyramidSeries;
	"QuadrantLineSeries": QuadrantLineSeries;
	"RadarChart": RadarChart;
	"RadarColumnSeries": RadarColumnSeries;
	"RadarCursor": RadarCursor;
	"RadarLineSeries": RadarLineSeries;
	"RadialGradient": RadialGradient;
	"RadialLabel": RadialLabel;
	"RadialText": RadialText;
	"Rectangle": Rectangle;
	"RectanglePattern": RectanglePattern;
	"RectangleSeries": RectangleSeries;
	"RegressionSeries": RegressionSeries;
	"RelativeStrengthIndex": RelativeStrengthIndex;
	"ResetControl": ResetControl;
	"RoundedRectangle": RoundedRectangle;
	"Sankey": Sankey;
	"SankeyLink": SankeyLink;
	"SankeyNodes": SankeyNodes;
	"Scrollbar": Scrollbar;
	"SerialChart": SerialChart;
	"SerialChartContainer": SerialChartContainer;
	"Serializer": Serializer;
	"Series": Series;
	"SeriesTypeControl": SeriesTypeControl;
	"SerpentineChart": SerpentineChart;
	"SettingsControl": SettingsControl;
	"SettingsModal": SettingsModal;
	"SimpleLineSeries": SimpleLineSeries;
	"Slice": Slice;
	"SliceGrouper": SliceGrouper;
	"SlicedChart": SlicedChart;
	"Slider": Slider;
	"SmoothedRadarLineSeries": SmoothedRadarLineSeries;
	"SmoothedXLineSeries": SmoothedXLineSeries;
	"SmoothedXYLineSeries": SmoothedXYLineSeries;
	"SmoothedYLineSeries": SmoothedYLineSeries;
	"SpiralChart": SpiralChart;
	"Sprite": Sprite;
	"SpriteResizer": SpriteResizer;
	"StandardDeviation": StandardDeviation;
	"Star": Star;
	"StarPattern": StarPattern;
	"StepLineSeries": StepLineSeries;
	"StochasticMomentumIndex": StochasticMomentumIndex;
	"StochasticOscillator": StochasticOscillator;
	"StockChart": StockChart;
	"StockControl": StockControl;
	"StockLegend": StockLegend;
	"StockPanel": StockPanel;
	"StockToolbar": StockToolbar;
	"Sunburst": Sunburst;
	"SuperTrend": SuperTrend;
	"Text": Text;
	"Tick": Tick;
	"Tooltip": Tooltip;
	"Tree": Tree;
	"Treemap": Treemap;
	"TrendLineSeries": TrendLineSeries;
	"Triangle": Triangle;
	"TrianglePattern": TrianglePattern;
	"Trix": Trix;
	"TypicalPrice": TypicalPrice;
	"VWAP": VWAP;
	"ValueAxis": ValueAxis<AxisRenderer>;
	"Venn": Venn;
	"VerticalLayout": VerticalLayout;
	"VerticalLineSeries": VerticalLineSeries;
	"Volume": Volume;
	"VolumeProfile": VolumeProfile;
	"VoronoiTreemap": VoronoiTreemap;
	"WilliamsR": WilliamsR;
	"WordCloud": WordCloud;
	"XYChart": XYChart;
	"XYChartScrollbar": XYChartScrollbar;
	"XYCursor": XYCursor;
	"XYSeries": XYSeries;
	"ZigZag": ZigZag;
	"ZoomControl": ZoomControl;
	"ZoomTools": ZoomTools;
	"ZoomableContainer": ZoomableContainer;
}
